import React from 'react';
import { useApi, oauthRequestApiRef } from '@backstage/core-plugin-api';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

/**
 * 세션 만료 시 Login Required 팝업 대신 새로고침 안내 다이얼로그 표시.
 * Backstage OAuthRequestDialog를 대체하여 사용자 혼란 방지.
 */
export const SessionRefreshDialog = () => {
  const [open, setOpen] = React.useState(false);
  const oauthRequestApi = useApi(oauthRequestApiRef);

  React.useEffect(() => {
    const subscription = oauthRequestApi.authRequest$().subscribe(requests => {
      if (requests.length > 0) {
        setOpen(true);
      }
    });
    return () => subscription.unsubscribe();
  }, [oauthRequestApi]);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!open) return null;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>세션이 만료되었습니다</DialogTitle>
      <DialogContent>
        <Box textAlign="center" py={1}>
          <Typography variant="body1" gutterBottom>
            인증 세션이 만료되어 데이터를 불러올 수 없습니다.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            페이지를 새로고침하면 자동으로 재인증됩니다.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
        >
          새로고침
        </Button>
      </DialogActions>
    </Dialog>
  );
};
